import type {ErrorInfo, PropsWithChildren, ReactElement} from 'react'
import {ErrorBoundary} from 'react-error-boundary'
import {logger} from 'src/common/logger'

const reloadPage = (): void => window.location.reload()

const Fallback = (): ReactElement => (
  <div role="alert" className="grid min-h-screen place-content-center gap-4 text-center">
    <p className="text-18">Something went wrong.</p>
    <button type="button" className="underline" onClick={reloadPage}>
      Reload page
    </button>
  </div>
)

const logRenderError = (error: unknown, {componentStack}: ErrorInfo): void =>
  logger.error('Unhandled React render error', {componentStack}, error)

export const AppErrorBoundary = ({children}: PropsWithChildren): ReactElement => (
  <ErrorBoundary FallbackComponent={Fallback} onError={logRenderError}>
    {children}
  </ErrorBoundary>
)
